'use client';

import { useEffect, useMemo } from 'react';
import { useGetPaymentMethodsQuery } from 'services/paymentMethodsApi';

import { Box, VStack } from '@chakra-ui/react';

import { ShopCartPayments } from 'types';

import { AddCardBox, PaymentCCardItem } from 'components/PaymentList';
import { Loader } from 'ui';

interface CreditCardListProps {
  onSelect: (cardId: number, isExist: boolean) => void;
  onAnotherCard: () => void;
  handleClearError?: () => void;
  selectedCards: ShopCartPayments[];
  isLoading: boolean;
}

const CreditCardList = ({
  onSelect,
  handleClearError = () => {},
  onAnotherCard,
  selectedCards,
  isLoading
}: CreditCardListProps) => {
  const { data: clientAccounts = [], isLoading: isCardStateLoading } =
    useGetPaymentMethodsQuery('', { refetchOnMountOrArgChange: true });

  const isCardsExist = clientAccounts && clientAccounts?.length > 0;

  const onSelectCard = (id: number, isExist: boolean) => () => {
    onSelect(id, isExist);
    handleClearError();
  };

  useEffect(
    () => () => {
      handleClearError();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  const accountList = useMemo(
    () => (Array.isArray(clientAccounts) ? clientAccounts : []),
    [clientAccounts]
  );

  const selectedCardsId = useMemo(
    () => selectedCards.map((c) => c.acct_id),
    [selectedCards]
  );

  return (
    <Box>
      {(isCardStateLoading || isLoading) && (
        <Loader fixed bg='blackOpacity.10' />
      )}
      <VStack gap='5px'>
        {accountList?.map((item, index) => (
          <PaymentCCardItem
            key={item.id}
            card={item}
            onSelectCard={onSelectCard(
              item.id,
              selectedCardsId.includes(item.id)
            )}
            isActive={selectedCardsId.includes(item.id)}
            isLast={(accountList?.length ?? 1) - 1 === index}
          />
        ))}

        <AddCardBox
          label={isCardsExist ? 'Add Another Credit Card' : 'Add Credit Card'}
          onSelectCard={onAnotherCard}
        />
      </VStack>
    </Box>
  );
};

export default CreditCardList;
